import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "alert",
  "use": "alert-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"alert\"><path fill=\"#333333\" d=\"M512 16.384C238.2848 16.384 16.384 238.2848 16.384 512c0 273.7664 221.9008 495.616 495.616 495.616s495.616-221.8496 495.616-495.616c0-273.7152-221.9008-495.616-495.616-495.616z m0 895.6416a94.1568 94.1568 0 1 1 0.1024-188.3136A94.1568 94.1568 0 0 1 512 912.0256z m94.1056-352.9728a94.1056 94.1056 0 0 1-188.2112 0V206.1312a94.1568 94.1568 0 0 1 188.2112 0v352.9216z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id